export default __webpack_public_path__ + "static/extraverdieping-desktop-7879c48a3a692044f277b67ec0f69741.svg";